var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}import { t } from "../../I18N";
import I18NLink from "../../I18N/components/I18NLink";

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';


import { Icon } from "../../UI";

const defaultProps = {
  quickLabelThesaurus: undefined
};



export class QuickLabelHeaderBase extends Component {


  render() {
    const { quickLabelThesaurus } = this.props;
    const thesaurusName = quickLabelThesaurus ? quickLabelThesaurus.get('name') : '';
    return /*#__PURE__*/(
      _jsx("div", { className: "content-header" }, void 0,
      !thesaurusName && /*#__PURE__*/
      _jsx("div", { className: "content-header-title" }, void 0, /*#__PURE__*/
      _jsx("h1", {}, void 0,
      t('System', 'Ooops... please go'), "\xA0", /*#__PURE__*/

      _jsx(I18NLink, { className: "btn btn-default", to: "/settings/dictionaries" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "arrow-left" }), "\xA0", /*#__PURE__*/

      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Back to thesauri'))))),




      thesaurusName && /*#__PURE__*/
      _jsx("div", { className: "content-header-title" }, void 0, /*#__PURE__*/
      _jsx(I18NLink, {
        className: "btn btn-default",
        to: `/settings/dictionaries/cockpit/${quickLabelThesaurus === null || quickLabelThesaurus === void 0 ? void 0 : quickLabelThesaurus.get('_id')}` }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "arrow-left" }), "\xA0", /*#__PURE__*/

      _jsx("span", { className: "btn-label" }, void 0, t('System', 'Back to thesaurus'))), /*#__PURE__*/

      _jsx("h1", {}, void 0, /*#__PURE__*/
      _jsx("span", { className: "large" }, void 0,
      t('System', 'Quick labeling for'), "\xA0", /*#__PURE__*/_jsx("b", {}, void 0, thesaurusName))))));






  }
}_defineProperty(QuickLabelHeaderBase, "defaultProps", defaultProps);

export const selectquickLabelThesaurus = createSelector(
(state) =>
state.thesauris.find(
(thes) => thes.get('_id') === state.library.sidepanel.quickLabelState.get('thesaurus')),

(thes) => thes);


export const mapStateToProps = (state) => ({
  quickLabelThesaurus: selectquickLabelThesaurus(state)
});

export const QuickLabelHeader = connect(mapStateToProps)(QuickLabelHeaderBase);